import { useMemo } from "react";
import styles from "./Property1Default.module.css";

const Property1Default = ({
  sectionTitle,
  property1DefaultBorderRadius,
  property1DefaultBackgroundColor,
  property1DefaultBoxShadow,
  property1DefaultPadding,
  property1DefaultBoxSizing,
}) => {
  const property1DefaultStyle = useMemo(() => {
    return {
      borderRadius: property1DefaultBorderRadius,
      backgroundColor: property1DefaultBackgroundColor,
      boxShadow: property1DefaultBoxShadow,
      padding: property1DefaultPadding,
      boxSizing: property1DefaultBoxSizing,
    };
  }, [
    property1DefaultBorderRadius,
    property1DefaultBackgroundColor,
    property1DefaultBoxShadow,
    property1DefaultPadding,
    property1DefaultBoxSizing,
  ]);

  return (
    <div className={styles.property1default} style={property1DefaultStyle}>
      <div className={styles.aboutMe}>{sectionTitle}</div>
    </div>
  );
};

export default Property1Default;
